module.exports = __webpack_public_path__ + "media/src/images/h5p_docu_2-6d2e8f65d8faa7af1afd6d39abca4448.png";